export interface IIdentifierObject {
  identifier: string;
}

export interface IRole extends IIdentifierObject {
  title: string;
  permissions: string[];
}

export interface IRoleEnabledUser {
  role: IRole;
}

export enum PermissionFormat {
  /** New common colon-separated format (subject_subject:action). */
  Common = 'common',

  /** Old underscore-separated format (action_subject_subject) used by core/cp. */
  Core = 'core',

  /** Old underscore-separated format (subject_subject_action) used by support. */
  Support = 'support',
}

/**
 * Object representing a permission. Contains action and subject.
 */
export interface IPermissionKey {
  /** Action being performed. */
  action: string;

  /** Entity on which the action is being performed. */
  subject: string;
}
